<template functional>
    <div class="tile-content tile-content-secondary">
        <p>Cancel all scheduled payments for the customer.</p>
    </div>
</template>

<script>
    export default {
        name: 'cancel-scheduled-payments',
    };
</script>
